import { Heading, Icon } from "@trueskin-web/components"
import { useIsScreenSizeSmall } from "@trueskin-web/theme"
import { checkIcon } from "@trueskin-web/theme/icons/checkIcon"

import PlanDetails from "./plan-details"

const SubscriptionPlanOverview = ({ title, subTitle, details }) => {
  const isMobile = useIsScreenSizeSmall()

  return (
    <div sx={{ mb: [0, 2] }}>
      <Heading as="h3" size="sm" sx={{ fontWeight: "bold" }}>
        {title}
      </Heading>
      <div sx={{ mt: 1 }}>{subTitle}</div>
      {isMobile && details.length > 0 && (
        <PlanDetails
          details={details}
          checkIcon={
            <Icon
              icon={checkIcon}
              color="primary"
              sx={{ transform: "scale(1.2)" }}
            />
          }
        />
      )}
    </div>
  )
}

export default SubscriptionPlanOverview
